<template>
  <div v-if="daily_message" class="text-center mb-6 pt-2">
    <p class="text-subtitle-1 font-italic font-weight-light" style="color: #212121; line-height: 1.8; word-break: keep-all;">
      "{{ daily_message }}"
    </p>
  </div>
</template>

<script>
export default {
  name: 'DailyMessage',
  data() {
    return {
      daily_message: '',
      messages_list: [
        '오늘도 하루가 저물어갑니다. 그만큼 만날 날이 하루 더 가까워졌어요.',
        '기다림은 사랑의 또 다른 이름입니다. 오늘도 힘내세요.',
        '어두운 밤이 지나면 반드시 밝은 아침이 옵니다.',
        '당신의 따뜻한 마음이 그 사람에게도 전해질 거예요.',
        '하루하루 채우는 이 시간은 결코 헛되지 않기에.',
        '가장 힘든 시간은 이미 지나갔습니다. 조금만 더 힘을 내요.',
        '함께할 그날을 그리며, 오늘도 건강하게 보내세요.'
      ]
    }
  },
  mounted() {
    this.GetDailyMessage()
  },
  methods: {
    /** 매일 다른 위로 메시지 가져오기 */
    GetDailyMessage() {
      const today = new Date()
      const index = (today.getFullYear() + today.getMonth() + today.getDate()) % this.messages_list.length
      this.daily_message = this.messages_list[index]
    }
  }
}
</script>

<style scoped>
</style>
